import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from 'kepler/lib/components/Button';
import Modal from 'kepler/lib/components/Modal';
import ModalBody from 'kepler/lib/components/ModalBody';
import i18n from '../../lib/reacti18n';
import { trackPage, trackLink } from '../../lib/analytics-helper';
import { showHideCovidBcpModalAlert } from '../actions/action-covid-modal-alert';
import Page from '../../lib/page';
import { initiateAsyncChat } from '../../lib/asyncMessageHelper';
import { asyncOrigins, chatBotMessageUsRefIdsMapping } from '../../common/commonConstants';
import { REF_SELECT_RESULT } from '../constants/PropTypesShapes';

const labels = {
  alertHeader: i18n.message('smarthelp/info.info.channelNotAvailable.infoMessageHeader'),
  asyncMessageText: i18n.message('smarthelp/info.info.channelNotAvailable.infoAsyncText'),
  asyncMessageSubText: i18n.message('smarthelp/info.info.channelNotAvailable.infoAsyncSubText'),
  nonAsyncMessageText: i18n.message('smarthelp/info.info.channelNotAvailable.infoNonAsyncText'),
  sendUsAMessage: i18n.message('smarthelp/contactLinksOption.message.messageUsLabel'),
};

class CovidBcpAlertContainer extends Component {
  static getAsyncNonAsyncLabel() {
    if (Page.isPilotUser()) {
      return 'async';
    }

    return 'non-async';
  }

  componentDidMount() {
    this.fireAlertImpressionEvent();
  }

  componentDidUpdate() {
    this.fireAlertImpressionEvent();
  }

  onClickMessageUsHandler() {
    trackLink({
      id: this.props.fpti_id,
      link: `smarthelp-covid-bcp-callUs-alert|${CovidBcpAlertContainer.getAsyncNonAsyncLabel()}|${this.getTopicRefId()}|send-us-a-message-click`,
    });

    this.closeCovidModalWindow();

    const topicRefId = this.getTopicRefId();
    const messageUsTopicRefId =
      topicRefId !== 'default'
        ? `${topicRefId}|${chatBotMessageUsRefIdsMapping.FINAL_INTENT}`
        : chatBotMessageUsRefIdsMapping.GENPOOL_CONTACT_US;

    return initiateAsyncChat({
      topicRefId: messageUsTopicRefId,
      origin: asyncOrigins.COVID_BCP_CALLUS_ALERT,
    });
  }

  getTopicRefId() {
    if (this.props.selectResult && this.props.selectResult.topicRefId) {
      return this.props.selectResult.topicRefId;
    }

    return 'default';
  }

  fireAlertImpressionEvent() {
    if (this.props.isModalOpen) {
      trackPage({
        id: this.props.fpti_id,
        link: `smarthelp-covid-bcp-callUs-alert|${CovidBcpAlertContainer.getAsyncNonAsyncLabel()}|${this.getTopicRefId()}|open`,
      });
    }
  }

  closeCovidModalWindow() {
    this.props.showHideCovidBcpModalAlert(false);
  }

  renderCorrespondingMessage() {
    if (Page.isPilotUser()) {
      return (
        <>
          <div className="covid-bcp-alert--message">{labels.asyncMessageText}</div>
          <div className="covid-bcp-alert--action-btn">
            <Button className="" onClick={() => this.onClickMessageUsHandler()} type="primary">
              {labels.sendUsAMessage}
            </Button>
          </div>
          <div className="covid-bcp-alert--subLabel">{labels.asyncMessageSubText}</div>
        </>
      );
    }

    return <div className="covid-bcp-alert--message">{labels.nonAsyncMessageText}</div>;
  }

  render() {
    return (
      <div className="covid-bcp-alert">
        <Modal
          isOpen={this.props.isModalOpen}
          type="dialog"
          width="medium"
          onCancel={() => this.closeCovidModalWindow()}
          backdropClosesModal={false}
        >
          <ModalBody>
            <div>
              <div className="covid-bcp-alert--header">{labels.alertHeader}</div>
              {this.renderCorrespondingMessage()}
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

CovidBcpAlertContainer.propTypes = {
  isModalOpen: PropTypes.bool,
  fpti_id: PropTypes.string,
  showHideCovidBcpModalAlert: PropTypes.func.isRequired,
  selectResult: PropTypes.shape(REF_SELECT_RESULT).isRequired,
};

CovidBcpAlertContainer.defaultProps = {
  fpti_id: 'covidBcpCallUsAlert',
  isModalOpen: false,
};

function mapStateToProps(state) {
  return {
    isModalOpen: state.covidBcp.isModalOpen,
    selectResult: state.selectResult.topicTreeSelectResult,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ showHideCovidBcpModalAlert }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CovidBcpAlertContainer);
